/* =========================================================
   FF Shopify Forms styling helper
   Styles Shopify Forms shadow DOM when theme CSS cannot reach it.
========================================================= */

(function () {
  if (window.FF_SHOPIFY_FORMS_INITIALIZED) return;
  window.FF_SHOPIFY_FORMS_INITIALIZED = true;

  const STYLE_ID = 'ff-shopify-forms-shadow-style';
  const HOST_SELECTORS = 'shopify-forms-embed, form-embed';
  const FORM_ROOT_SELECTOR = '[data-forms-id^="forms-root-"]';
  const SCAN_TARGET_SELECTOR = `${FORM_ROOT_SELECTOR}, ${HOST_SELECTORS}`;
  const FORM_LAYOUT_CLASS = 'ff-has-shopify-form';
  const FORM_LAYOUT_TARGETS = [
    '.ff-apps-card',
    '.ff-section__card',
    '.ffac-content',
    '.ffac-block',
    '.shopify-block',
    '.shopify-app-block'
  ].join(', ');

  /*
    Only style real customer-facing fields.
    Do not style captcha/system fields such as h-captcha-response or g-recaptcha-response.
  */
  const HIDDEN_FIELD_EXCLUSIONS = [
    ':not([hidden])',
    ':not([aria-hidden="true"])',
    ':not([style*="display: none" i])',
    ':not([style*="display:none" i])'
  ].join('');

  const CUSTOMER_INPUT_SELECTOR = [
    `input${HIDDEN_FIELD_EXCLUSIONS}`,
    ':not([type="hidden"])',
    ':not([type="radio"])',
    ':not([type="checkbox"])',
    ':not([type="file"])'
  ].join('');

  const CUSTOMER_TEXTAREA_SELECTOR = [
    `textarea${HIDDEN_FIELD_EXCLUSIONS}`,
    ':not([name="h-captcha-response"])',
    ':not([id^="h-captcha-response"])',
    ':not([name="g-recaptcha-response"])',
    ':not([id^="g-recaptcha-response"])'
  ].join('');

  const CUSTOMER_SELECT_SELECTOR = `select${HIDDEN_FIELD_EXCLUSIONS}`;

  const CUSTOMER_FIELD_SELECTOR = [
    CUSTOMER_INPUT_SELECTOR,
    CUSTOMER_TEXTAREA_SELECTOR,
    CUSTOMER_SELECT_SELECTOR
  ].join(',\n    ');

  const CUSTOMER_FIELD_HOVER_SELECTOR = [
    `${CUSTOMER_INPUT_SELECTOR}:hover`,
    `${CUSTOMER_TEXTAREA_SELECTOR}:hover`,
    `${CUSTOMER_SELECT_SELECTOR}:hover`
  ].join(',\n    ');

  const CUSTOMER_FIELD_FOCUS_SELECTOR = [
    `${CUSTOMER_INPUT_SELECTOR}:focus`,
    `${CUSTOMER_TEXTAREA_SELECTOR}:focus`,
    `${CUSTOMER_SELECT_SELECTOR}:focus`
  ].join(',\n    ');

  const CUSTOMER_PLACEHOLDER_SELECTOR = [
    `${CUSTOMER_INPUT_SELECTOR}::placeholder`,
    `${CUSTOMER_TEXTAREA_SELECTOR}::placeholder`
  ].join(',\n    ');

  const css = `
    :host {
      color: #505050 !important;
      font-family: inherit !important;
      font-size: 16px !important;
      line-height: 1.6 !important;
    }

    *,
    *::before,
    *::after {
      box-sizing: border-box !important;
    }

    /* =====================================================
       Layout width
    ===================================================== */

    div[class*="gridItem"],
    div[class*="gridItemContent"],
    form[data-testid="form"],
    form[class*="formFieldset"],
    form,
    section,
    [data-testid="form-container"] {
      width: 100% !important;
      max-width: 720px !important;
      margin-inline: auto !important;
      color: #505050 !important;
      font-family: inherit !important;
      font-size: 16px !important;
      line-height: 1.6 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      background: transparent !important;
    }

    form,
    section,
    [data-testid="form-container"] {
      margin-block: 0 !important;
      padding: 0 !important;
    }

    /* =====================================================
       Topic / radio groups
    ===================================================== */

    fieldset,
    [role="group"] {
      margin: 0 0 2rem !important;
      padding: 0 !important;
      border: 0 !important;
    }

    fieldset[class*="radioFieldSet"] {
      margin: 0 0 3rem !important;
      padding: 0 !important;
      border: 0 !important;
    }

    fieldset[class*="radioFieldSet"] > legend[class*="radioLegend"],
    legend,
    fieldset > label:first-child,
    [class*="legend"],
    [class*="Legend"],
    [class*="field-title"],
    [class*="FieldTitle"],
    [class*="group-title"],
    [class*="GroupTitle"] {
      display: block !important;
      margin: 0 !important;
      padding: 0 !important;
      color: #607359 !important;
      font-family: inherit !important;
      font-size: clamp(16px, 15.26px + 0.19vw, 18px) !important;
      line-height: 1.3 !important;
      font-weight: 500 !important;
      letter-spacing: 0 !important;
      text-align: left !important;
    }

    fieldset[class*="radioFieldSet"] > div[class*="verticalLayout"] {
      display: grid !important;
      gap: 1.05rem !important;
      margin-top: 1.65rem !important;
    }

    fieldset label,
    [role="group"] label,
    fieldset[class*="radioFieldSet"] label[class*="radioField"] {
      display: inline-flex !important;
      align-items: center !important;
      gap: 0.75rem !important;
      width: fit-content !important;
      min-height: 28px !important;
      margin: 0 !important;
      padding: 0 !important;
      color: #505050 !important;
      font-family: inherit !important;
      font-size: 16px !important;
      line-height: 1.45 !important;
      font-weight: 400 !important;
      letter-spacing: 0.01em !important;
      text-align: left !important;
    }

    fieldset[class*="radioFieldSet"] label[class*="radioField"] span[class*="textBody"] {
      color: #505050 !important;
      font-size: 16px !important;
      line-height: 1.45 !important;
      font-weight: 400 !important;
    }

    /* =====================================================
       Generic labels and headings
    ===================================================== */

    h1,
    h2,
    h3,
    h4,
    [class*="heading"],
    [class*="Heading"] {
      color: #607359 !important;
      font-family: inherit !important;
      font-size: clamp(16px, 15.26px + 0.19vw, 18px) !important;
      line-height: 1.3 !important;
      font-weight: 500 !important;
      letter-spacing: 0 !important;
      text-align: left !important;
    }

    label {
      color: #505050 !important;
      font-family: inherit !important;
      font-size: 16px !important;
      line-height: 1.45 !important;
      font-weight: 400 !important;
      letter-spacing: 0.01em !important;
    }

    /* =====================================================
       Text fields
    ===================================================== */

    ${CUSTOMER_FIELD_SELECTOR} {
      width: 100% !important;
      min-height: 52px !important;
      padding: 14px 16px !important;
      border: 1px solid #dde3d9 !important;
      border-radius: 0 !important;
      background: #ffffff !important;
      color: #505050 !important;
      box-shadow: none !important;
      outline: none !important;
      font-family: inherit !important;
      font-size: 16px !important;
      line-height: 1.45 !important;
      font-weight: 400 !important;
      letter-spacing: 0.01em !important;
    }

    ${CUSTOMER_FIELD_HOVER_SELECTOR} {
      border-color: rgba(96, 115, 89, 0.42) !important;
    }

    ${CUSTOMER_FIELD_FOCUS_SELECTOR} {
      border-color: #607359 !important;
      box-shadow: 0 0 0 1px #607359 !important;
    }

    ${CUSTOMER_PLACEHOLDER_SELECTOR} {
      color: rgba(80, 80, 80, 0.58) !important;
      opacity: 1 !important;
    }

    ${CUSTOMER_TEXTAREA_SELECTOR} {
      display: block !important;
      min-height: 150px !important;
      padding-top: 14px !important;
      resize: vertical !important;
      line-height: 1.55 !important;
    }

    /* =====================================================
       Radio / checkbox controls
    ===================================================== */

    input[type="radio"],
    input[type="checkbox"] {
      appearance: none !important;
      -webkit-appearance: none !important;
      display: inline-grid !important;
      place-items: center !important;
      width: 18px !important;
      height: 18px !important;
      min-width: 18px !important;
      min-height: 18px !important;
      margin: 0 !important;
      padding: 0 !important;
      border: 1px solid rgba(80, 80, 80, 0.58) !important;
      background: #ffffff !important;
      box-shadow: none !important;
      cursor: pointer !important;
    }

    input[type="radio"] {
      border-radius: 999px !important;
    }

    input[type="checkbox"] {
      border-radius: 0 !important;
    }

    input[type="radio"]::before,
    input[type="checkbox"]::before {
      content: "" !important;
      background: #607359 !important;
      transform: scale(0) !important;
    }

    input[type="radio"]::before {
      width: 8px !important;
      height: 8px !important;
      border-radius: 999px !important;
    }

    input[type="checkbox"]::before {
      width: 9px !important;
      height: 9px !important;
    }

    input[type="radio"]:checked,
    input[type="checkbox"]:checked {
      border-color: #607359 !important;
    }

    input[type="radio"]:checked::before,
    input[type="checkbox"]:checked::before {
      transform: scale(1) !important;
    }

    /* =====================================================
       Date fields
    ===================================================== */

    [data-testid="date-birthday"],
    [class*="date"],
    [class*="Date"] {
      gap: 10px !important;
    }

    [class*="birthdayText"],
    [class*="BirthdayText"] {
      color: #505050 !important;
      font-family: inherit !important;
      font-size: 16px !important;
      line-height: 1.45 !important;
      font-weight: 400 !important;
      letter-spacing: 0.01em !important;
    }

    /* =====================================================
       File upload
    ===================================================== */

    input[type="file"],
    [class*="dropzone"],
    [class*="Dropzone"],
    [class*="upload"],
    [class*="Upload"],
    [class*="file-upload"],
    [class*="FileUpload"],
    [class*="formFileInput"] {
      border-radius: 0 !important;
      box-shadow: none !important;
      font-family: inherit !important;
      font-size: 15px !important;
    }

    [class*="dropzone"],
    [class*="Dropzone"],
    [class*="upload"],
    [class*="Upload"],
    button[class*="formFileInputField"] {
      min-height: 112px !important;
      border: 1px dashed #cfd8ca !important;
      background: #ffffff !important;
    }

    p[class*="formFileInputButton"] {
      color: #505050 !important;
      font-size: 15px !important;
      line-height: 1.3 !important;
    }

    /* =====================================================
       Submit button
    ===================================================== */

    button,
    [type="submit"],
    [role="button"] {
      min-height: 48px !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      text-shadow: none !important;
      background-image: none !important;
      font-family: inherit !important;
      font-size: 16px !important;
      font-weight: 500 !important;
      line-height: 1.2 !important;
      letter-spacing: 0 !important;
    }

    button[type="submit"],
    [type="submit"],
    button[data-testid="btn-form-submit"],
    button[class*="formSubmitButton"] {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 100% !important;
      min-height: 54px !important;
      margin-top: 1.1rem !important;
      padding: 0.9rem 1.75rem !important;
      border: 1px solid #607359 !important;
      border-radius: 0 !important;
      outline: 1px solid rgba(255, 255, 255, 0.55) !important;
      outline-offset: -3px !important;
      background: #607359 !important;
      background-image: none !important;
      color: #ffffff !important;
      box-shadow: none !important;
      text-shadow: none !important;
      font-family: inherit !important;
      font-size: 16px !important;
      line-height: 1.2 !important;
      font-weight: 500 !important;
      letter-spacing: 0.01em !important;
    }

    button[type="submit"]:hover,
    [type="submit"]:hover,
    button[data-testid="btn-form-submit"]:hover,
    button[class*="formSubmitButton"]:hover {
      background: #4f6348 !important;
      border-color: #4f6348 !important;
      color: #ffffff !important;
      filter: none !important;
    }

    button[type="submit"]:focus-visible,
    [type="submit"]:focus-visible,
    button[data-testid="btn-form-submit"]:focus-visible,
    button[class*="formSubmitButton"]:focus-visible {
      outline: 2px solid #607359 !important;
      outline-offset: 3px !important;
    }

    /* =====================================================
       Disclaimer / helper text
    ===================================================== */

    small,
    p,
    [class*="legal"],
    [class*="Legal"],
    [class*="privacy"],
    [class*="Privacy"],
    [class*="disclaimer"],
    [class*="Disclaimer"],
    [class*="consent"],
    [class*="Consent"],
    [class*="helper"],
    [class*="Helper"],
    [class*="description"],
    [class*="Description"],
    [class*="formDisclaimer"] {
      color: rgba(80, 80, 80, 0.78) !important;
      font-family: inherit !important;
      font-size: 14px !important;
      line-height: 1.5 !important;
      letter-spacing: 0.01em !important;
    }

    a {
      color: #607359 !important;
      text-decoration: underline !important;
      text-decoration-thickness: 1px !important;
      text-underline-offset: 0.45em !important;
      text-decoration-color: rgba(96, 115, 89, 0.45) !important;
    }

    /* =====================================================
       Mobile
    ===================================================== */

    @media (max-width: 699px) {
      div[class*="gridItem"],
      div[class*="gridItemContent"],
      form[data-testid="form"],
      form[class*="formFieldset"],
      form,
      section,
      [data-testid="form-container"] {
        max-width: 100% !important;
      }

      fieldset[class*="radioFieldSet"] > legend[class*="radioLegend"],
      legend,
      fieldset > label:first-child,
      [class*="legend"],
      [class*="Legend"],
      [class*="field-title"],
      [class*="FieldTitle"],
      [class*="group-title"],
      [class*="GroupTitle"] {
        font-size: 17px !important;
      }

      fieldset[class*="radioFieldSet"] > div[class*="verticalLayout"] {
        margin-top: 1.35rem !important;
        gap: 0.95rem !important;
      }

      ${CUSTOMER_FIELD_SELECTOR} {
        min-height: 50px !important;
        padding: 13px 14px !important;
      }

      button[type="submit"],
      [type="submit"],
      button[data-testid="btn-form-submit"],
      button[class*="formSubmitButton"] {
        min-height: 52px !important;
      }
    }
  `;

  function injectIntoShadowRoot(shadowRoot) {
    if (!shadowRoot || shadowRoot.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    shadowRoot.appendChild(style);
  }

  function markFormLayout(formRoot) {
    let target = formRoot.closest(FORM_LAYOUT_TARGETS);

    while (target) {
      target.classList.add(FORM_LAYOUT_CLASS);
      target = target.parentElement ? target.parentElement.closest(FORM_LAYOUT_TARGETS) : null;
    }
  }

  function markFormLayouts() {
    document
      .querySelectorAll(SCAN_TARGET_SELECTOR)
      .forEach(markFormLayout);
  }

  function scan() {
    markFormLayouts();

    document.querySelectorAll(HOST_SELECTORS).forEach((host) => {
      if (host.shadowRoot) {
        injectIntoShadowRoot(host.shadowRoot);
      }
    });
  }

  let scanTimer = null;

  function scheduleScan(delay) {
    const wait = typeof delay === 'number' ? delay : 120;
    window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(scan, wait);
  }

  function nodeMayContainForm(node) {
    if (!(node instanceof Element)) return false;

    return (
      node.matches?.(SCAN_TARGET_SELECTOR) ||
      Boolean(node.querySelector?.(SCAN_TARGET_SELECTOR))
    );
  }

  scan();

  window.setTimeout(scan, 300);
  window.setTimeout(scan, 900);
  window.setTimeout(scan, 1800);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (nodeMayContainForm(node)) {
          scheduleScan();
          return;
        }
      }
    }
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('shopify:section:load', scheduleScan);
})();
